import { ReactNode } from 'react';
import { useAuth } from './useAuth';

interface RoleGuardProps {
  children: ReactNode;
  role: string;
  fallback?: ReactNode;
}

export const RoleGuard = ({ children, role, fallback = null }: RoleGuardProps) => {
  const { roles, isLoading, featuresLoaded } = useAuth();

  if (isLoading || !featuresLoaded) {
    return null;
  }

  const hasRole = roles.some((currentRole) =>
    currentRole?.localeCompare(role, undefined, { sensitivity: 'accent' }) === 0
  );

  return hasRole ? <>{children}</> : <>{fallback}</>;
};
